import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DividerComponent } from '../../divider/divider.component';
import { TruncateComponent } from '../../truncate/truncate.component';

/**
 * @description Use for __heading__ in top of dropdown and __subheading__ in the middle of it.
 * @description In html mark left item (e.g. icon) as __'prefix'__ to render it in left spot.
 * @description Mark right item as __'suffix'__.
 *
 *
 *  __> INPUTS:__
 *  - __fullWidthTitle__: _boolean_ - disable rendering of prefix and suffix for full width header text.
 *  - __isSubheading__: _boolean_ - change styles for subheading elements and add top divider.
 *  - __hasTopDivider__: _boolean_ - force top divider to render.
 *
 */

@Component({
  selector: 'rt-dropdown-header',
  templateUrl: './dropdown-header.component.html',
  styleUrls: ['./dropdown-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.full-width]': 'fullWidthTitle()',
    '[class.subheading]': 'isSubheading()', // change styles for subheading elements.
  },
  imports: [TruncateComponent, DividerComponent],
})
export class DropdownHeaderComponent {
  public readonly fullWidthTitle = input<boolean>(false);
  public readonly isSubheading = input<boolean>(false);
  public readonly hasTopDivider = input<boolean>(false);
}
